import React from 'react';
import {
  Constants,
  CommentTarget,
  CommentType,
} from '@pwc/pwc-deals-web-common';

import './PageSection.scss';
import { useParams } from 'react-router-dom';
import ShowForRole from '../../../features/security/ShowForRole';
import { sanitize } from '../../services/sanitizeService';
import RichTextReadOnlyComment from '../RichTextForm/RichTextReadOnlyComment';
import { useIsAddingCommentEnabled } from '../../hooks/useIsAddingCommentEnabled';

const PageDescription = ({ label, value, sectionId }) => {
  const { projectId } = useParams();

  const isAddingCommentEnabled = useIsAddingCommentEnabled();

  return value ? (
    <>
      <ShowForRole
        roles={Constants.USER_ROLE_GROUPS.INTERNAL}
        projectId={projectId}
      >
        <div className="section-name">{label}</div>
      </ShowForRole>
      {!isAddingCommentEnabled && (
        <p
          className="section-text"
          data-testid={`page-${sectionId || label.toLowerCase()}`}
          dangerouslySetInnerHTML={{ __html: sanitize(value) }}
        />
      )}

      {isAddingCommentEnabled && (
        <RichTextReadOnlyComment
          richText={value}
          commentTarget={CommentTarget.Description}
          commentType={CommentType.RichText}
          libraryItemId={CommentTarget.Description}
        />
      )}
    </>
  ) : null;
};

export default PageDescription;
